import { render, staticRenderFns } from "./LeumiCardMaxCredsHelpPopup.vue?vue&type=template&id=5796ba69&scoped=true"
import script from "./LeumiCardMaxCredsHelpPopup.vue?vue&type=script&lang=js"
export * from "./LeumiCardMaxCredsHelpPopup.vue?vue&type=script&lang=js"
import style0 from "./LeumiCardMaxCredsHelpPopup.vue?vue&type=style&index=0&id=5796ba69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5796ba69",
  null
  
)

export default component.exports